<div class="isg-full-page-header">

  <div class="isg-page-header">
    <span>Log - Page Views</span>
  </div>
  <div class="isg-page-body">

    <kendo-grid [data]="gridData"
                (pageChange)="pageChange($event)"
                [skip]="skip"
                [pageable]="{
               buttonCount:10,
               info:true,
               pageSizes:true,
               previousNext:true,
               responsive:true,
               position: 'bottom'
           }"
                [pageSize]="pageSize"
                [style.height]="'100%'"
                [rowClass]="rowCallback">
      <ng-template kendoGridToolbarTemplate>
        <input placeholder="Search..."
               kendoTextBox
               (input)="onFilter($event.target)" />
        <kendo-grid-spacer></kendo-grid-spacer>
        <button kendoGridExcelCommand type="button" title="Export to Excel">
          <span class="fas fa-file-excel"></span>
        </button>
      </ng-template>
      <kendo-grid-column [hidden]="true" field="id" title="Id">
      </kendo-grid-column>
      <kendo-grid-column field="loggedOn" title="Logged On" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.loggedOn | utcToLocal }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="loggedBy" title="Logged By" [width]="300">
      </kendo-grid-column>
      <kendo-grid-column field="url" title="Url">
      </kendo-grid-column>
      <kendo-grid-excel [fetchData]="allData" fileName="PageLogs_Dump.xlsx"></kendo-grid-excel>
      <ng-template kendoPagerTemplate
                   let-totalPages="totalPages"
                   let-currentPage="currentPage">


        <div class="custom-pager">
          <div class="custom-pager-pagesize">View&nbsp;&nbsp; <kendo-dropdownlist [data]="sizes" [(ngModel)]="pageSize" (valueChange)="pageSizeChange($event)"></kendo-dropdownlist></div>
          <div class="custom-pager-jump"><kendo-pager-input></kendo-pager-input></div>
          <div class="custom-pager-items"><kendo-pager-prev-buttons></kendo-pager-prev-buttons> {{startnum()}} - {{endnum()}} of {{gridData.total}} <kendo-pager-next-buttons></kendo-pager-next-buttons></div>
        </div>
      </ng-template>
    </kendo-grid>

  </div>

</div>
